import { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function AccountPage() {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'login';
  const [isLogin, setIsLogin] = useState(true);

  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-md mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <div className="text-center mb-8">
              <div className="w-20 h-20 bg-gold-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-line text-4xl text-gold-600"></i>
              </div>
              <h1 className="text-2xl font-bold text-gray-800 mb-2">
                {isLogin ? 'Hesabınıza Giriş Yapın' : 'Üye Olun'}
              </h1>
              <p className="text-gray-600 text-sm">
                {isLogin
                  ? 'Siparişlerinizi takip edin, favorilerinizi yönetin'
                  : 'Hızlı alışveriş için üye olun'}
              </p>
            </div>

            {isLogin ? (
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    E-posta Adresi
                  </label>
                  <input
                    type="email"
                    placeholder="ornek@email.com"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold-500 text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Şifre
                  </label>
                  <input
                    type="password"
                    placeholder="••••••••"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold-500 text-sm"
                  />
                </div>

                <div className="flex items-center justify-between text-sm">
                  <label className="flex items-center cursor-pointer">
                    <input type="checkbox" className="mr-2" />
                    <span className="text-gray-600">Beni Hatırla</span>
                  </label>
                  <button
                    type="button"
                    className="text-gold-600 hover:text-gold-700 cursor-pointer"
                  >
                    Şifremi Unuttum
                  </button>
                </div>

                <button
                  type="submit"
                  className="w-full bg-gold-600 text-white py-3 rounded-lg font-semibold hover:bg-gold-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Giriş Yap
                </button>

                <div className="relative my-6">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-4 bg-white text-gray-500">veya</span>
                  </div>
                </div>

                <button
                  type="button"
                  className="w-full border-2 border-gray-300 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  <i className="ri-google-fill text-xl"></i>
                  Google ile Giriş Yap
                </button>

                <div className="text-center mt-6">
                  <p className="text-gray-600 text-sm">
                    Hesabınız yok mu?{' '}
                    <button
                      type="button"
                      onClick={() => setIsLogin(false)}
                      className="text-gold-600 font-semibold hover:text-gold-700 cursor-pointer"
                    >
                      Üye Ol
                    </button>
                  </p>
                </div>
              </form>
            ) : (
              <form className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Ad
                    </label>
                    <input
                      type="text"
                      placeholder="Adınız"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold-500 text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Soyad
                    </label>
                    <input
                      type="text"
                      placeholder="Soyadınız"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold-500 text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    E-posta Adresi
                  </label>
                  <input
                    type="email"
                    placeholder="ornek@email.com"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold-500 text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Telefon
                  </label>
                  <input
                    type="tel"
                    placeholder="0532 123 45 67"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold-500 text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Şifre
                  </label>
                  <input
                    type="password"
                    placeholder="En az 6 karakter"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold-500 text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Şifre Tekrar
                  </label>
                  <input
                    type="password"
                    placeholder="Şifrenizi tekrar girin"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold-500 text-sm"
                  />
                </div>

                <label className="flex items-start cursor-pointer text-sm">
                  <input type="checkbox" className="mt-1 mr-2" />
                  <span className="text-gray-600">
                    <Link to="/kvkk" className="text-gold-600 hover:text-gold-700">
                      KVKK
                    </Link>{' '}
                    ve{' '}
                    <Link to="/kullanim-kosullari" className="text-gold-600 hover:text-gold-700">
                      Kullanım Koşulları
                    </Link>
                    'nı okudum, kabul ediyorum.
                  </span>
                </label>

                <button
                  type="submit"
                  className="w-full bg-gold-600 text-white py-3 rounded-lg font-semibold hover:bg-gold-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Üye Ol
                </button>

                <div className="relative my-6">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-4 bg-white text-gray-500">veya</span>
                  </div>
                </div>

                <button
                  type="button"
                  className="w-full border-2 border-gray-300 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  <i className="ri-google-fill text-xl"></i>
                  Google ile Üye Ol
                </button>

                <div className="text-center mt-6">
                  <p className="text-gray-600 text-sm">
                    Zaten hesabınız var mı?{' '}
                    <button
                      type="button"
                      onClick={() => setIsLogin(true)}
                      className="text-gold-600 font-semibold hover:text-gold-700 cursor-pointer"
                    >
                      Giriş Yap
                    </button>
                  </p>
                </div>
              </form>
            )}
          </div>

          <div className="mt-8 grid grid-cols-3 gap-4 text-center">
            <div className="bg-white rounded-lg shadow-sm p-4">
              <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-shield-check-line text-2xl text-gold-600"></i>
              </div>
              <p className="text-xs text-gray-600">Güvenli Alışveriş</p>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-4">
              <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-truck-line text-2xl text-gold-600"></i>
              </div>
              <p className="text-xs text-gray-600">Sigortalı Kargo</p>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-4">
              <div className="w-12 h-12 bg-gold-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-customer-service-2-line text-2xl text-gold-600"></i>
              </div>
              <p className="text-xs text-gray-600">7/24 Destek</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
